// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__Jfjah","inputWrap":"styles_inputWrap__1h774","input":"styles_input__2Szz8"};